import { derived } from "svelte/store";
import { locale } from "svelte-i18n";
import { IntlMessageFormat } from "intl-messageformat";
import en from "./t-en.json";
import ja from "./t-ja.json";

// 한글 원문을 키로 쓰는 번역 헬퍼 (gettext / Vue-i18n "no-keys" 스타일) + ICU 지원.
//
// 사용:
//   {$t('편집하기')}                                   // 단순 번역
//   {$t('새 {name} 만들기', { name })}                 // 보간(interpolation)
//   {$t('{count, plural, other {#개 항목}}', { count })} // 복수형(ICU plural)
//
//   - ko(또는 사전 미보유 로케일): 한글 원문을 템플릿으로 사용 → 코드가 곧 원본
//   - en/ja: 사전에 매핑 있으면 그 문구를, 없으면 한글 원문으로 폴백(누락돼도 안 깨짐)
//   - values 인자가 있을 때만 ICU 파싱 → 값 없는 대다수 문구는 빠른 경로(원문 그대로)
//
// 기존 svelte-i18n의 $_('project.main.X') 키 방식과 공존. 언어 전환은 동일한
// svelte-i18n locale 스토어를 구독하므로 헤더 언어 셀렉트와 자동 연동된다.
const dicts = { en, ja };
const cache = new Map(); // `${locale} ${template}` → IntlMessageFormat (파싱 캐시)

function format(loc, template, values) {
	// 값이 없으면 ICU 파싱 없이 원문 그대로(빠르고, 의도치 않은 {}/' 해석 방지)
	if (values == null) return template;
	const key = loc + " " + template;
	let mf = cache.get(key);
	if (!mf) {
		try {
			mf = new IntlMessageFormat(template, loc);
		} catch (e) {
			return template; // ICU 문법 오류 시 원문 폴백
		}
		cache.set(key, mf);
	}
	try {
		return mf.format(values);
	} catch (e) {
		return template;
	}
}

export const t = derived(locale, ($locale) => {
	const loc = $locale || "ko";
	const dict = dicts[loc] || null;
	return (ko, values) => {
		const template = (dict && dict[ko]) || ko; // 한글 원문을 키로 조회, 없으면 한글
		return format(loc, template, values);
	};
});
